if (process.env.CI) {
  process.env.STYTCH_PROJECT_ID = 'test'
  process.env.STYTCH_SECRET = 'secret'
  process.env.STYTCH_PROJECT_ENV = 'https://test.stytch.com/'
  process.env.NEXT_PUBLIC_STYTCH_PUBLIC_TOKEN = 'public'
  process.env.NEXT_PUBLIC_STYTCH_REDIRECT_URL = 'http://localhost:3235'
}

const sessionDurationInMinutes = process.env
  .NEXT_PUBLIC_SESSION_TIMEOUT_IN_MINUTES
  ? parseInt(process.env.NEXT_PUBLIC_SESSION_TIMEOUT_IN_MINUTES)
  : 45 // based on the happy-next-dashboard

export const stytchConfig = {
  projectId: process.env.STYTCH_PROJECT_ID!,
  secret: process.env.STYTCH_SECRET!,
  projectEnv: process.env.STYTCH_PROJECT_ENV!,
  otpTimeoutInMinutes: process.env.STYTCH_OTP_TIMEOUT_IN_MINUTES
    ? parseInt(process.env.STYTCH_OTP_TIMEOUT_IN_MINUTES)
    : 10,
  sessionDurationInMinutes
}

export const stytchClientConfig = {
  publicToken: process.env.NEXT_PUBLIC_STYTCH_PUBLIC_TOKEN!,
  redirectUrl: process.env.NEXT_PUBLIC_STYTCH_REDIRECT_URL!,
  sessionDurationInMinutes
}
